import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { GradesView } from '@/modules/lessonDetails'
import { courseQueryOptions } from '@/queries/useCourse'
import { groupQueryOptions } from '@/queries/useGroup'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'
import { columnsSchema } from '@/utils/zod'

export const Route = createFileRoute(
  '/_auth/timetable/$courseId/$groupId/grades'
)({
  validateSearch: z.object({
    semesterId: z.string().catch(''),
    ...columnsSchema.shape
  }),
  component: GradesView,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context, params }) => {
    const [group, course] = await Promise.all([
      context.queryClient.ensureQueryData(groupQueryOptions(params.groupId)),
      context.queryClient.ensureQueryData(courseQueryOptions(params.courseId))
    ])

    if (
      !search.semesterId ||
      !isSelectedSemesterInOptions(search.semesterId, group.semestersOptions)
    ) {
      throw redirect({
        replace: true,
        to: '/timetable/$courseId/$groupId/grades',
        params,
        search: {
          semesterId: group.currentSemester.id
        }
      })
    }

    return course.name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.grades', { ns: 'lessonDetails' })
    ])
})
